const screens = {
  sm: '360px',
  md: '480px',
  lg: '768px',
  xl: '1024px',
}

export { screens }
